import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import './compareDate.css'

export default function WeekMonthComparisonFilter({
  filterType,
  week1,
  week2,
  month1,
  month2,
  onTypeChange,
  onValueChange,
}) {
  return (
    <div className="d-flex flex-wrap gap-2 align-items-center">
      <FormGroup className='marginBottom0'>
        <Label for="filterType">Compare By</Label>
        <Input
        style={{width:'170px'}}
          type="select"
          id="filterType"
          value={filterType}
          onChange={(e) => onTypeChange(e.target.value)}
        >
          <option value="week">Week</option>
          <option value="month">Month</option>
        </Input>
      </FormGroup>

      {filterType === 'week' && (
        <>
          <FormGroup className='marginBottom0'>
            <Label for="week1">Week 1</Label>
            <Input
            style={{width:'170px'}}
              type="week"
              id="week1"
              value={week1}
              onChange={(e) => onValueChange('week1', e.target.value)}
              max={new Date().toISOString().slice(0, 10)}
            />
          </FormGroup>
          <FormGroup className='marginBottom0'>
            <Label for="week2">Week 2</Label>
            <Input
            style={{width:'170px'}}
              type="week"
              id="week2"
              value={week2}
              onChange={(e) => onValueChange('week2', e.target.value)}
              max={new Date().toISOString().slice(0, 10)}
            />
          </FormGroup>
        </>
      )}

      {filterType === 'month' && (
        <>
          <FormGroup className='marginBottom0' style={{marginBottom:'0'}}>
            <Label for="month1">Month 1</Label>
            <Input
            style={{width:'170px'}}
              type="month"
              id="month1"
              value={month1}
              onChange={(e) => onValueChange('month1', e.target.value)}
              max={new Date().toISOString().slice(0, 7)}
            />
          </FormGroup>
          <FormGroup className='marginBottom0'>
            <Label for="month2">Month 2</Label>
            <Input
            style={{width:'170px'}}
              type="month"
              id="month2"
              value={month2}
              onChange={(e) => onValueChange('month2', e.target.value)}
              max={new Date().toISOString().slice(0, 7)}
            />
          </FormGroup>
        </>
      )}
    </div>
  );
}
